export interface FormErrorAlertItemProps {
  href: string,
  anchorText: string,
  errorDescription: string
  'data-testid'?: string
  onClick?: () => void
}

export const FormErrorAlertItem: React.FC<FormErrorAlertItemProps> = ({
  href,
  anchorText,
  errorDescription,
  onClick,
  ...props
}) => (
  <li>
    <a href={href} data-testid={props['data-testid']} onClick={onClick}>
      {anchorText}
    </a>
    {': '}
    <span>
      {errorDescription}
    </span>
  </li>
)
